module.exports = __webpack_public_path__ + "img/pdd.1d3a05b2.png";